/**
 * @generated SignedSource<<ab4a396f7aa9dbfc62eb46704e5070a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutStickySubmitButton_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSubmitButton_item">;
  readonly " $fragmentType": "CheckoutStickySubmitButton_item";
};
export type CheckoutStickySubmitButton_item$key = {
  readonly " $data"?: CheckoutStickySubmitButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutStickySubmitButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutStickySubmitButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ff92f97979ebe841055e01243e780922";

export default node;
